import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import {
  toggleLoginForm,
  authStep,
  updateAuthStep
} from '../../state/actions/stepActions'
import Button from '../button'
import Result from '../result'
import * as Locale from '../../state/authLocale'
import { connect } from 'react-redux'

import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

class AuthModal extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { dispatch } = this.props
    dispatch(authStep({}))
  }

  getResource(key, property) {
    /**
     * @remarks locale forced to it
     * @todo internationalization
     */
    return Locale.getResource(key, 'it', property)
  }

  getInputType(callbackType) {
    let res = ''
    switch (callbackType) {
      case 'PasswordCallback':
        res = 'password'
        break
      default:
        res = 'text'
        break
    }
    return res
  }

  onValueChange(e) {
    const { auth, dispatch } = this.props

    auth.callbacks.find(
      c => !!c.input && c.input[0].name === e.target.name
    ).input[0].value =
      e.target.value

    dispatch(updateAuthStep(auth))
  }

  handleClick(/*e*/) {
    const { dispatch } = this.props
    dispatch(toggleLoginForm(false))
  }

  getOutputType(val) {
    const map = { '0': 'info', '1': 'warning', '2': 'error' }
    return map[val]
  }

  printOutputCallbacks() {
    const { auth, styles } = this.props

    if (!!auth.callbacks) {
      return auth.callbacks
        .filter(callback => callback.type === 'TextOutputCallback')
        .map((callback, index) => (
          <Result
            key={index}
            title={this.getResource('MESSAGE_TYPE_' + callback.output[1].value)}
            type={this.getOutputType(callback.output[1].value)}
          >
            <div>{this.getResource(callback.output[0].value)}</div>
            {callback.output[0].value === 'USER_CODE' ? (
              <div>
                <h1 {...css(styles.title)}>Sei già cliente Sella.it</h1>
                <div {...css(styles.subtitle)}>
                  <div>Diventare cliente è ancora più semplice!</div>
                  <div>
                    Effettua l'accesso per continuare con la registrazione
                    semplificata.
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
            {callback.output[0].value === 'ERROR_PASSWORD_EXPIRED' ? (
              <div>
                &Egrave; possibile richiedere lo sblocco seguendo la procedura
                dal portale{' '}
                <a rel="nofollow" href="https://www.sella.it" target="_blank">
                  sella.it
                </a>
              </div>
            ) : (
              ''
            )}
            {callback.output[0].value.indexOf('WARN_PASSWORD_REMINDER:') >
            -1 ? (
              <div>
                &Egrave; possibile aggiornare ora la password seguendo la
                procedura dal portale{' '}
                <a rel="nofollow" href="https://www.sella.it" target="_blank">
                  sella.it
                </a>
              </div>
            ) : (
              ''
            )}
            {callback.output[0].value === 'ERROR_PIN_EXPIRED' ? (
              <div>
                &Egrave; possibile richiedere lo sblocco seguendo la procedura
                dal portale{' '}
                <a rel="nofollow" href="https://www.sella.it" target="_blank">
                  sella.it
                </a>
              </div>
            ) : (
              ''
            )}
            {callback.output[0].value.indexOf('WARN_PIN_REMINDER:') > -1 ? (
              <div>
                &Egrave; possibile aggiornare ora il PIN seguendo la procedura
                dal portale{' '}
                <a rel="nofollow" href="https://www.sella.it" target="_blank">
                  sella.it
                </a>
              </div>
            ) : (
              ''
            )}
          </Result>
        ))
    }
  }

  printInputCallbacks() {
    const { auth, styles } = this.props

    if (!!auth.callbacks) {
      return auth.callbacks
        .filter(callback => callback.type !== 'TextOutputCallback')
        .map((callback, index) => (
          <div
            key={index}
            {...css(styles.component, styles['component--block'])}
          >
            {callback.input.map((input, iindex) => (
              <input
                key={iindex}
                name={input.name}
                type={this.getInputType(callback.type)}
                value={input.value}
                {...css(styles.input)}
                placeholder={this.getResource(
                  callback.output[iindex].value,
                  'placeholder'
                )}
                onChange={event => {
                  this.onValueChange(event)
                }}
              />
            ))}
            {callback.output
              .filter(output => output.name === 'prompt')
              .map((output, oindex) => (
                <span
                  key={oindex}
                  {...css(
                    styles.label,
                    styles['label--auth'],
                    callback.input[oindex].value !== '' &&
                      styles['label--active']
                  )}
                  dangerouslySetInnerHTML={{
                    __html: this.getResource(output.value, 'label')
                  }}
                />
              ))}
          </div>
        ))
    }
  }

  printTitle() {
    const { auth, styles } = this.props

    if (!!auth.callbacks) {
      return auth.callbacks
        .filter(callback => callback.type !== 'TextOutputCallback')
        .map((callback, index) => {
          if (callback.output[0].value === 'USER_CODE') {
            return (
              <div key={index}>
                <h1 {...css(styles.title)}>Sei già cliente Sella.it</h1>
                <div {...css(styles.subtitle)}>
                  <div>Diventare cliente è ancora più semplice!</div>
                  <div>
                    Effettua l'accesso per continuare con la registrazione
                    semplificata.
                  </div>
                </div>
              </div>
            )
          } else if (callback.output[0].value === 'INSERT_RSA_OTP') {
            return (
              <div key={index}>
                <h1 {...css(styles.title)}>Inserisci il codice del token</h1>
                <div {...css(styles.token)} />
              </div>
            )
          }
        })
    }
  }

  getProperErrorMessage(errorMessage) {
    switch (errorMessage) {
      case 'Dear colleague,<BR/>We got a system error during Authentication process!!':
        return 'Errore durante il processo di autenticazione, si prega di riprovare.'
      case 'Invalid two password chars entered.':
        return 'I caratteri di controllo immessi non sono validi'
      default:
        return errorMessage
    }
  }

  render() {
    const { dispatch, auth, isCloseButtonHidden, styles } = this.props
    return (
      <div {...css(styles.modal)}>
        <div {...css(styles.bg)} />
        {!isCloseButtonHidden ? (
          <div
            {...css(styles.closeBtn)}
            onClick={event => this.handleClick(event)}
          />
        ) : (
          ''
        )}
        <div {...css(styles.wrapper)}>
          <div {...css(styles.content)}>
            {!!auth.errorMessage ? (
              <Result title={this.getResource('MESSAGE_TYPE_1')} type="error">
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.getProperErrorMessage(auth.errorMessage)
                  }}
                />
              </Result>
            ) : (
              ''
            )}

            {this.printTitle()}
            {this.printOutputCallbacks()}
            {this.printInputCallbacks()}
            <div {...css(styles.buttons)}>
              {!auth.errorMessage ? (
                <Button
                  type={'sella'}
                  action={() => dispatch(authStep(auth))}
                  text={'Login'}
                />
              ) : (
                <Button
                  type={'sella'}
                  action={() => dispatch(authStep({}))}
                  text={'Riprova'}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

AuthModal.propTypes = {
  auth: PropTypes.object,
  isCloseButtonHidden: PropTypes.bool,
  styles: PropTypes.object.isRequired
}

const mapStateToProps = state => {
  const { auth } = state.step
  return { ...state, auth: auth || {} }
}

export default connect(mapStateToProps)(withStyles(Styles)(AuthModal))



// WEBPACK FOOTER //
// ./components/authmodal/index.js